<div class="container-fluid py-4 px-5">
  <div class="bg-primary text-white rounded-3 shadow-sm p-3 mb-4">
    <h2 class="h4 mb-0 fw-bold">Búsqueda de Productos</h2>
  </div>

  <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="row g-2 align-items-center mb-4">
    <div class="col-md-6 col-lg-8">
      <input type="text" formControlName="term" class="form-control form-control-lg shadow-sm"
        placeholder="Buscar por código INE o nombre del producto..." />
    </div>

    <div class="col-md-auto d-flex gap-2">
      <button type="submit" class="btn btn-primary btn-lg px-4 shadow-sm">
        <i class="bi bi-search"></i> Buscar
      </button>

      <button type="button" (click)="onListAll()" class="btn btn-outline-secondary btn-lg px-4 shadow-sm">
        <i class="bi bi-list-ul"></i> Consultar todos
      </button>
      <button type="button" (click)="exportExcel()" class="btn btn-success btn-lg px-4 shadow-sm"
        [disabled]="!products().length"><i class="bi bi-file-earmark-excel"></i> Exportar Excel</button>
    </div>
  </form>

  @if (loading()) {
    <div class="text-center text-primary fw-semibold py-3">
      <div class="spinner-border text-primary me-2"></div>
      Cargando productos...
    </div>
  }

  @if (error()) {
    <div class="alert alert-danger text-center">{{ error() }}</div>
  }

  @if (hasSearched() && !loading() && products().length === 0) {
    <div class="alert alert-warning text-center">
      <i class="bi bi-exclamation-circle"></i> No se encontraron resultados.
    </div>
  }

  @if (products().length > 0) {
    <div class="table-responsive shadow-sm rounded-3">
      <table class="table table-hover align-middle mb-0">
        <thead style="background-color: #0d47a1; color: #ffffff;">
          <tr>
            <th>Código INE</th>
            <th>Nombre</th>
            <th>CIIU</th>
            <th>NAEG</th>
            <th>NPG</th>
            <th>CCP</th>
            <th>Referencia</th>
            <th>Estado</th>
            <th>Sección</th>
            <th>División</th>
            <th>Clase</th>
            <th class="text-center">Acciones</th>
          </tr>
        </thead>

        <tbody class="bg-white">
          @for (p of products(); track p.codigo) {
          <tr>
            <td>{{ p.codigoIne }}</td>
            <td>{{ p.nombre }}</td>
            <td>{{ p.codigoCiiu }}</td>
            <td>{{ p.codigoNaeg }}</td>
            <td>{{ p.codigoNpg }}</td>
            <td>{{ p.codigoCcp }}</td>
            <td>{{ p.referencia }}</td>

            <td>
              <span [class.text-success]="p.estado === 'A'" [class.text-danger]="p.estado === 'I'">
                {{ p.estado === 'A' ? 'Activo' : 'Inactivo' }}
              </span>
            </td>

            <td>{{ p.fkSeccion }}</td>
            <td>{{ p.fkDivision }}</td>
            <td>{{ p.fkClase }}</td>

            <td class="text-center">
              <div class="d-flex justify-content-center gap-2">
                <button class="btn btn-sm btn-outline-primary"
                        (click)="openEdit(p)">
                  <i class="bi bi-pencil-square"></i>
                </button>

                <button class="btn btn-sm btn-outline-info"
                        title="Ver Variedades"
                        (click)="viewVarieties(p.codigo ?? 0)">
                  <i class="bi bi-diagram-3"></i>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<!-- MODAL EDIT -->
<app-modal-edit-product
  [product]="selectedProduct"
  (deleted)="onProductDeleted($event)"
  (updated)="onProductUpdated($event)">
</app-modal-edit-product>
